export default __webpack_public_path__ + "static/media/heat.ada3de7a.png";